(() => {
const init = root => root.querySelectorAll('[data-zp-hero]').forEach(hero => {
 if(hero.dataset.ready) return; hero.dataset.ready='true';
 const video=hero.querySelector('video'), data=hero.querySelector('[data-zp-video]'), button=hero.querySelector('.zp-motion');
 if(!video || !data) return;
 const motion=matchMedia('(prefers-reduced-motion: reduce)'), mobile=matchMedia('(max-width: 749px)');
 const sources=JSON.parse(data.textContent);
 const configure=()=>{
  video.pause(); video.removeAttribute('src'); video.load(); button.hidden=true;
  if(motion.matches) return;
  const available=(mobile.matches?sources.mobile:sources.desktop)||sources.desktop||sources.mobile||[];
  const mp4=available.filter(s=>s.mime_type==='video/mp4').sort((a,b)=>a.height-b.height);
  const selected=mp4.find(s=>s.height>=(mobile.matches?720:1080))||mp4.at(-1);
  if(!selected) return; video.src=selected.url; video.muted=true; video.autoplay=true;
  video.play().then(()=>{button.hidden=false;button.textContent=button.dataset.pause;button.setAttribute('aria-pressed','false');}).catch(()=>{});
 };
 button.addEventListener('click',()=>{if(video.paused){video.play().catch(()=>{});button.textContent=button.dataset.pause;button.setAttribute('aria-pressed','false');}else{video.pause();button.textContent=button.dataset.play;button.setAttribute('aria-pressed','true');}});
 motion.addEventListener('change',configure);mobile.addEventListener('change',configure);configure();
});
init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();